import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { colors } from 'Constants/Colors';
import tabList from './style';

export default function TabPage({ tabsTitle = [], pages = [] }) {
  const [value, setValue] = useState('0');

  const handleChange = (_, newValue) => {
    setValue(newValue);
  };
  return (
    <TabContext value={value}>
      <Box sx={{ background: 'white' }}>
        <TabList
          onChange={handleChange}
          TabIndicatorProps={{
            style: { background: colors.GREEN },
          }}
        >
          {tabsTitle.map((title, i) => {
            const id = title + i;
            return <Tab key={id} label={title} value={`${i}`} style={tabList(value, i)} />;
          })}
        </TabList>
      </Box>
      {pages.map((page, i) => {
        const id = i.toString();
        return (
          <TabPanel key={id} value={id}>
            {page}
          </TabPanel>
        );
      })}
    </TabContext>
  );
}
